import { transformCommaSeparatedNumbers } from "@/utils/urlFilterParams";

export const OA_QUERY_FILTER_MAPPINGS = [
	{
		filterKey: "status",
		queryParam: "status",
		transformValue: transformCommaSeparatedNumbers,
	},
	{
		filterKey: "type",
		queryParam: "type",
		transformValue: transformCommaSeparatedNumbers,
	},
	{
		filterKey: "business_id",
		queryParam: "business",
		legacyQueryParams: ["business_id"],
		transformValue: (rawValue) => (rawValue === "" ? "" : Number(rawValue)),
	},
	{
		filterKey: "internal_code",
		queryParam: "internal_code",
	},
	{
		filterKey: "season_id",
		queryParam: "season",
		legacyQueryParams: ["season_id"],
		transformValue: (rawValue) => (rawValue === "" ? "" : Number(rawValue)),
	},
	{
		filterKey: "date_start",
		queryParam: "date_start",
	},
	{
		filterKey: "date_end",
		queryParam: "date_end",
	},
];

export const OA_ROUTE_ACTIONS = {
	preview: "vista_previa",
	notice: "dar_aviso",
	consumeProducts: "consumir_productos",
	recalculatePrices: "recalcular_precios",
};

export const OA_ROUTE_PARAM_KEYS = {
	action: "action",
	oa: "oa",
	file: "file",
	code: "code",
};

export const OA_DOCUMENT_FILE_KEY = "application_orders";
